// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OLl9","left":"styles_left__11b1b","desktopActions":"styles_desktopActions__3fPB8","title":"styles_title__paYTj"};